// extracted by mini-css-extract-plugin
module.exports = {"navlink":"formLogin_navlink__1FXR6","googleBtn":"formLogin_googleBtn__1Yfvp","googleBtnHide":"formLogin_googleBtnHide__1ke4X"};